import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Table } from "../../../components/Table/Table";
import {
  delete_icon,
  view_icon,
  search_icon,
  edit_icon,
  green_icon,
  red_icon,
} from "../../../assets/imgs";
import { companyList } from "../../redux/api/dummyJson";
import { get, post } from "../../../Services/ApiHandler";
import { URL } from "../../../Services/Constant";
import { toast } from "react-toastify";
import moment from "moment/moment";
import useSearch from "../../../components/Searchbox/useSearch";
import Header from "../../../components/Header";

const AdminCompanyList = () => {
  const navigate = useNavigate();
  const givenpermissions = JSON.parse(localStorage.getItem("user_permission"));
  const [list, setList] = useState([]);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const searchVal = useSearch(search);
  const [pagination, setPagination] = useState(1);
  const [popup, setPopup] = useState(false);

  const handleStatus = (id) => {
    get(URL.COMPANY_STATUS + id)
      .then((res) => {
        if (res?.status == "success") {
          toast.success(res?.message);
          getCompanyList("");
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "sno",
        Cell: ({ value, row }) => {
          return <p>{(page - 1) * 10 + row.index + 1}</p>;
        },
      },
      {
        Header: "Company Code",
        accessor: "company_code",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Company & location",
        accessor: "company_name",
        Cell: ({ value, row }) => {
          return (
            <div className="d-flex flex-column gap-2">
              <p>{value}</p>
              <p>{row.original.location}</p>
            </div>
          );
        },
      },

      {
        Header: "Number of sites",
        accessor: "site_count",
        Cell: ({ value, row }) => {
          return (
            <div className="d-flex flex-row ac-jc gap-3">
              <p className="mt-3">{value}</p>
              <button
                onClick={() => {
                  navigate("/add-company", {
                    state: { type: "view", data: row.original },
                  });
                  // AdminView(row.original.id, "view");
                }}
                className="cust-btn "
              >
                <img src={view_icon} alt="" className=" edit-btn " />
              </button>
            </div>
          );
        },
      },
      {
        Header: "Primary person",
        accessor: "knf_user_name",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Mobile & Email",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <div className="d-flex flex-column gap-2">
              <p>{row.original.knf_user_phone}</p>
              <p>{row.original.knf_user_email}</p>
              <div className="d-flex ac-jc mb-2 gap-2">
                <img
                  src={
                    row?.original?.knf_user_is_email_verified
                      ? green_icon
                      : red_icon
                  }
                  className="redImg"
                />
                <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                  {row?.original?.knf_user_is_email_verified
                    ? "Verified"
                    : "Not Verified"}
                </p>
              </div>
            </div>
          );
        },
      },
      {
        Header: "Company Created by",
        accessor: "created_by",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Company Created On",
        accessor: "company_created_at",
        Cell: ({ value, row }) => {
          return <p>{value ? moment(value).format("DD-MM-YYYY") : "-"}</p>;
        },
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value, row }) => {
          return (
            <div>
              <button
                onClick={() => {
                  if (
                    givenpermissions?.includes("CAN-Status-KNF_ADMIN_COMPANY")
                  ) {
                    handleStatus(row.original.id);
                  }
                }}
                className={`${
                  value ? "active-btn" : "deactive-btn"
                } border-0 f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13 fs-xxl-18 ${
                  givenpermissions?.includes("CAN-Status-KNF_ADMIN_COMPANY")
                    ? ""
                    : "opacity-50"
                }`}
              >
                {value ? "Active" : "De-active"}
              </button>
            </div>
          );
        },
      },
      {
        Header: "Action",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <React.Fragment>
              <div className="d-flex ac-jc gap-1 mx-1">
                {givenpermissions?.includes("CAN-Edit-KNF_ADMIN_COMPANY") && (
                  <button
                    onClick={() => {
                      navigate("/admin-add-company", {
                        state: { type: "edit", data: row.original },
                      });
                    }}
                    className="cust-btn "
                  >
                    <img src={edit_icon} alt="" className=" edit-btn " />
                  </button>
                )}
                {/* {givenpermissions?.includes("CAN-Delete-KNF_ADMIN_COMPANY") && (
                  <button
                    onClick={() => setPopup(true)}
                    // onClick={() => setDeletePopup(row.original.id)}
                    className="cust-btn "
                  >
                    <img src={delete_icon} alt="" className=" edit-btn " />
                  </button>
                )} */}
              </div>
            </React.Fragment>
          );
        },
      },
    ],
    [page],
  );

  const getCompanyList = (search_) => {
    let formdata = new FormData();
    formdata.append("page", page);
    formdata.append("search", search_);

    post(URL.KNF_COMPANY_LIST, formdata)
      .then((res) => {
        setList(res?.lists);
        setPagination(res?.pagination_meta);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    getCompanyList(searchVal);
  }, [searchVal, page]);

  return (
    <div className="dashRightView ">
      <Header type={"Company"} />
      <div className="d-flex ac-jb">
        <h2 className=" f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 ">
          Total:{pagination?.total ?? 0}
        </h2>
        <div className="d-flex gap-3">
          <div className="search-input">
            <input
              onChange={(e) => setSearch(e.target.value)}
              value={search}
              type="text"
              placeholder="Search"
              style={{ border: "none", width: "150px" }}
            />
            <img src={search_icon} className="search" />
          </div>
          {givenpermissions?.includes("CAN-Add-KNF_ADMIN_COMPANY") && (
            <button
              onClick={() =>
                navigate("/admin-add-company", { state: { type: "add" } })
              }
              className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 white add-btn "
            >
              {" "}
              + Add Company
            </button>
          )}
        </div>
      </div>
      <Table
        columns={columns}
        setPageno={setPage}
        pagecount={pagination}
        data={list ?? []}
        show={true}
      />
      {popup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <p className="f3 ms-2  ms-md-2 ms-lg-2 ms-xl-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-4">
              Are you sure, want to Delete?
            </p>
            <div className="d-flex ac-jb px-2 mt-5">
              <button onClick={() => setPopup(false)} className="add-btn w-40">
                Yes
              </button>
              <button
                onClick={() => {
                  setPopup(false);
                  // logout();
                }}
                className="back-btn f2 w-40"
              >
                {/* {loading ? "Loading..." : "Confirm"} */}No
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminCompanyList;
